import { render, staticRenderFns } from "./TablaEstadisticas.vue?vue&type=template&id=206a7cee&scoped=true&"
import script from "./TablaEstadisticas.vue?vue&type=script&lang=js&"
export * from "./TablaEstadisticas.vue?vue&type=script&lang=js&"
import style0 from "./TablaEstadisticas.vue?vue&type=style&index=0&id=206a7cee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206a7cee",
  null
  
)

export default component.exports